<template>
  <div class="btn-zoom-to-geolocation" v-if="geolocationPermissionStatus === 'granted'">

    <svg
      @click="zoomToCurrentLocation()"
      class="w-6 h-6"
      alt="GPS current location icon"
      title="Press to zoom to current position">
      <use xlink:href="#current-geolocation"></use>
    </svg>

  </div>
</template>

<script>
import { EventBus } from '@/eventBus'
import { mapGetters } from 'vuex'

export default {
  name: 'GPSButton',
  computed: {
    ...mapGetters({
      geolocationSettings: 'settings/getCompleteNavigatorGeolocationObjectSettings',
      geolocationPermissionStatus: 'settings/getGeolocationPermissionStatus',
      currentLat: 'geolocation/getCurrentGeolocation.lat',
      currentLon: 'geolocation/getCurrentGeolocation.lon'
    })
  },
  mounted () {
    this.$nextTick(() => {
    })
  },
  methods: {
    zoomToCurrentLocation () {
      // console.log('this.geolocationPermissionStatus =', this.geolocationPermissionStatus)
      // console.log('this.geolocationSettings =', this.geolocationSettings)
      // this.$l.log('GPSButton', 'zoomToCurrentLocation invoked, calls EventBus')
      EventBus.$emit('zoomIntoCenter', false)
      EventBus.$emit('centerMap')
    }
  }
}
</script>

<style lang="postcss" scoped>
.btn-zoom-to-geolocation {
  @apply absolute top-44 left-3;
  @apply w-7 h-7;
  @apply flex items-center justify-center;
  @apply text-pink-100  bg-pink-800;
  @apply cursor-pointer select-none rounded-full;
}

.btn-zoom-to-geolocation:active,
.btn-zoom-to-geolocation:hover {
  @apply bg-pink-700;
}

</style>
